module.exports = ({
    "TITLE.CREATE": "Create a new exam"
});